import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { GoodsPhoto, GoodsCategory, GoodsFilter, NoResult } from '../../../js/ComponentManager'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { DataContext } from '../../Layout';
/* 개발담당:양유빈
 * 화면기능:상가별,층별 상품보기
 * 세부설명:
*/

export class StoreGoodsList extends Component {
    static displayName = StoreGoodsList.name;
    static contextType = DataContext;
    constructor(props) {
        super(props);
        this.state = {
            TotalCount: 0,
            Flr_Code:"",
            GoodsList: []
        };

        this.CsName = Big3Common.ContentState;
        this.GoodsCategoryRef = React.createRef();
        this.GoodsFilterRef = React.createRef();
        
        this.Bld_Code = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Bld_Code, "");
        this.FlrList = Big3Common.Util.GetContentState(this.props.ContentState, "FlrList", []);
        this.Flr_Code = "";//검색에서 사용

        this.CategoryCallback = this.CategoryCallback.bind(this);
        this.handelFilterInit = this.handelFilterInit.bind(this);
        this.FilterCallback = this.FilterCallback.bind(this);
        this.handleAddMore_Click = this.handleAddMore_Click.bind(this);
        this.handleGoodsDtl_Click = this.handleGoodsDtl_Click.bind(this);
        this.handleFlrCode_Click = this.handleFlrCode_Click.bind(this);
        this.handle_onScroll = this.handle_onScroll.bind(this);
    }
    //초기화
    async componentDidMount () {
        //안드로이드 백버튼 제어
        window.addEventListener('scroll', this.handle_onScroll);
        await this.CallSearchGoodsList(true);       
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handle_onScroll);
    } 
    //스크롤바 페이징
     
    handle_onScroll() {
        if (Big3Common.WebConfig.ScrollEvent === false) {
            return false;
        }
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 1) {
            Big3Common.WebConfig.ScrollEvent = false;
            this.handleAddMore_Click()
        }
    }
    SearchModel = {
        Bld_Code: "",
        Flr_Code: "",
        Man_Cd: "",
        Mid_Cd: "",
        Sub_Cd: "",
        Display: "all",
        Order_By: "reg_dt",
        Start_Price: 0,
        End_Price: 1000000,
        Goods_Nm: "",
        Page_Number: 1,
        Page_Size: Big3Common.WebConfig.Page_Size
    }
    async CallSearchGoodsList(isAppend) {
        try {
            Big3Common.Util.LoadingOn();
            this.SearchModel.Bld_Code = this.Bld_Code;
            this.SearchModel.Flr_Code = this.Flr_Code;
            let Data = await Big3Common.Post('api/Search/Goods/GetSearchGoodsCategoryList', this.SearchModel, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);
                const TotalCount = (this.SearchModel.Page_Number * this.SearchModel.Page_Size);
                if (isAppend) {
                    //페이징 처리
                    let GoodListPush = this.state.GoodsList;
                    DataList.map(list => GoodListPush.push(list));
                    this.setState({
                        GoodsList: GoodListPush,
                        TotalCount: TotalCount
                    });
                }
                else {
                    this.setState({
                        GoodsList: DataList,
                        TotalCount: TotalCount
                    });
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallSearchGoodsList", e);
        }
        finally {
            Big3Common.WebConfig.ScrollEvent = true;
            Big3Common.Util.LoadingOff();
        }

        return false;
    }
    //필터 조건받음
    FilterCallback(Filter) {

        this.SearchModel.Display = Filter.Display;
        this.SearchModel.Order_By = Filter.Order_By;
        this.SearchModel.Start_Price = Filter.Start_Price;
        this.SearchModel.End_Price = Filter.End_Price;

        this.SearchModel.Page_Number = 1;
        this.CallSearchGoodsList();
    }
    //필터 초기화
    handelFilterInit() {
        this.GoodsFilterRef.current.handleClear_Click();
        this.SearchModel.Flr_Code = "";
        this.SearchModel.Man_Cd = "";
        this.SearchModel.Mid_Cd = "";
        this.SearchModel.Sub_Cd = "";
        this.SearchModel.Display = "all";
        this.SearchModel.Order_By = "reg_dt";
        this.SearchModel.Start_Price = 0;
        this.SearchModel.End_Price = 1000000;

        this.SearchModel.Page_Number = 1;
        this.CallSearchGoodsList();
    }
    //카테고리 필터조건 Callback 함수
    CategoryCallback(CategoryCd) {

        this.SearchModel.Man_Cd = CategoryCd.Man_Cd;
        this.SearchModel.Mid_Cd = CategoryCd.Mid_Cd;
        this.SearchModel.Sub_Cd = CategoryCd.Sub_Cd;

        this.SearchModel.Page_Number = 1;
        this.CallSearchGoodsList();
    }

    //상품더보기
    handleAddMore_Click() {
        console.log("handleAddMore_Click")
        this.SearchModel.Page_Number++;
        this.CallSearchGoodsList(true);
    }
    //상품상세보기 클릭
    async handleGoodsDtl_Click(e, goods_no, uid) {
        
        this.context.Layout_GoodsDtl(
            {
                goods_no: goods_no,
                uid: uid,
                isshow: true,
                headhide: true,
                scrollevent: false
            });
    }
    //층클릭
    handleFlrCode_Click = (event, flr_code) => {
        this.setState({
            Flr_Code: flr_code
        });
        this.Flr_Code = flr_code;
        this.CallSearchGoodsList();
        event.preventDefault();
    }
    
    //카테고리
    category_render() {

        const Flr_Code = this.state.Flr_Code;
        function SwiperClassName(text, flr_code) {
            let len = text.length;
            let Css = `category `;
            if (len < 4) {
                Css += `category${4 - 2}`;
            }
            else if (len >= 4)
            {
                Css += `category${len - 1}`;
            }
            else {
                Css += " category1";
            }
            if (flr_code === Flr_Code) {
                Css += " selected";
            }
            return Css
        }
        return (
            <Swiper watchSlidesProgress={true} slidesPerView={5} className="small_category_box">
                <SwiperSlide className={this.state.Flr_Code === "" ? "category category4 selected" : "category category4"} onClick={(e) => { this.handleFlrCode_Click(e, "") }}>
                    <div>전체보기</div>
                    </SwiperSlide>
                    {
                        this.FlrList.map(list =>
                            <SwiperSlide className={SwiperClassName(list.flr_name, list.flr_code)}
                                key={list.flr_code}
                                onClick={(e) => { this.handleFlrCode_Click(e, list.flr_code) }}>
                                <div> {list.flr_name}</div>
                            </SwiperSlide>

                        )}
                    <SwiperSlide>
                        {/* 공백*/}
                    </SwiperSlide>
            </Swiper>
        )
    }
    goodslist_render = () => {
        const GoodsList = this.state.GoodsList;
        return (
            <div className="recent_poroducts row row-cols-3 result">
                {GoodsList.map(list =>
                    <div className="product" key={list.file_no} onClick={(e) => { this.handleGoodsDtl_Click(e, list.goods_no, list.uid) }}>
                        <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                            Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
                            CallBack={this.CallBoorkMarkGoodsData}
                            SoldoutYn={list.soldout_yn}
                            SimilarityYn="Y"
                        />
                        <div className="shop_name">{list.org_nm}</div>
                        <div className="product_name">{list.goods_nm}</div>
                        <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                        {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                    </div>
                )}
                {this.state.TotalCount === this.state.GoodsList.length ? <div className="more_btn_box"><button className="more_btn" onClick={this.handleAddMore_Click}>더 보기</button></div> : ""}
            </div>
        )
    }
    render() {
        return (
            <>
                <div id="parent_goods_list">
                    <div className="p_margin u_padding container_box">
                        {this.category_render()}
                        <div className="recent_product result_box">
                            <div className="select_box">
                                <div className="category_box"
                                    onClick={(event) => {
                                        Big3Common.ModalAlert(bootstrap, 'GoodsCategory');
                                        event.preventDefault();
                                    }}
                                >
                                    <div className="category">카테고리</div>
                                    <div className="category_btn"></div>
                                </div>
                                <div className="category_box filter"
                                    onClick={(event) => {
                                        Big3Common.ModalAlert(bootstrap, 'GoodsFilter');
                                        event.preventDefault();
                                    }}
                                >
                                    <div className="category filter">필터</div>
                                    <div className="category_btn"></div>
                                </div>
                                <div className="category_box reset" onClick={this.handelFilterInit}>
                                    <div className="category">초기화</div>
                                    <div className="reset_btn"></div>
                                </div>
                            </div>
                            {this.goodslist_render()}
                        </div>
                    </div>
                    <NoResult
                        Visible={this.state.GoodsList.length === 0 ? true : false}
                        Top={"50%"}
                    />
                    <GoodsCategory
                        id="GoodsCategory"
                        CallBack={this.CategoryCallback}
                        ref={this.GoodsCategoryRef}
                    />
                    <GoodsFilter
                        id="GoodsFilter"
                        CallBack={this.FilterCallback}
                        ref={this.GoodsFilterRef}
                    />
                </div>
            </>
        );
    }
}
